import * as React from "react";
const SvgFiRrTally = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tally_svg__a)">
      <path
        fill="#062147"
        d="M23.912 6.655a1 1 0 0 0-1.321-.503L22 6.417V1a1 1 0 1 0-2 0v6.314l-4 1.795V1a1 1 0 1 0-2 0v9.006l-4 1.795V1a1 1 0 0 0-2 0v11.698l-4 1.795V1a1 1 0 0 0-2 0v14.39l-1.41.632a1 1 0 1 0 .82 1.824l.59-.265v5.418a1 1 0 1 0 2 0v-6.316l4-1.794v8.11a1 1 0 1 0 2 0v-9.006l4-1.794v10.802a1 1 0 1 0 2 0v-11.7l4-1.794v13.494a1 1 0 1 0 2 0V8.609l1.41-.632a1 1 0 0 0 .502-1.322"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tally_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTally;
